import type { Project, ScopeTarget } from "../api";

/** Where the demo scan is: 0 RECON … 5 REPORT (completed). Advanced by the
 *  tour, never by the clock — a real scan runs for hours, the demo moves on
 *  each time the user presses Next. */
export type Checkpoint = 0 | 1 | 2 | 3 | 4 | 5;

export interface DemoScan {
  scan_id: string;
  status: "running" | "paused" | "completed";
  checkpoint: Checkpoint;
  /** Moved back on every checkpoint so the timer shows the real timescale. */
  started_at: string;
  completed_at: string | null;
  /** How many of the checkpoint's events are in the feed already — the
   *  script reveals them one per tick so the feed and graph animate. */
  revealed: number;
  /** When the scan was paused (the timer freezes there); null while running. */
  paused_at: string | null;
}

export interface DemoState {
  /** The host the user typed; names the project and is substituted into
   *  findings, events and the report. */
  host: string | null;
  project: Project | null;
  target: ScopeTarget | null;
  scan: DemoScan | null;
  readNotificationIds: string[];
}

export type DemoEvent = { type: "reveal-tick" };

export interface ScheduledEvent {
  /** Absolute time (Date.now() based) — survives a reload. */
  at: number;
  event: DemoEvent;
}

export const initialDemoState = (): DemoState => ({
  host: null,
  project: null,
  target: null,
  scan: null,
  readNotificationIds: [],
});
